import mixpanel from 'mixpanel-browser';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service';
import { getLogRocketSessionURL, trackLogRocketEvent } from '@Services/analytics/logrocket.service';
import type { ExperienceResult } from '@Services/convert/types';

const apiKey = getEnvironmentVariable(EnvironmentVariables.VITE_APP_MIXPANEL);

const _isTrackingServiceEnabled = () => import.meta.env.VITE_TRACKING_ENABLED === 'true';
export const initTrackingService = () => {
  if (!_isTrackingServiceEnabled()) return;
  mixpanel.init(apiKey || '', { debug: import.meta.env.VITE_MIXPANEL_DEBUG === 'true' });
  mixpanel.track('Mixpanel Initialized', { appVersion: '1' }); // @TODO check with devOps

  getLogRocketSessionURL((sessionURL) => {
    mixpanel.track('LogRocket', { sessionURL });
  });
};

export const identifyTrackingServiceUser = (customerId: string) => {
  if (!_isTrackingServiceEnabled()) return;
  if (!customerId) {
    mixpanel.reset();
  } else {
    mixpanel.identify(customerId);
  }
};

export const setPeopleProperty = (props = {}) => {
  if (!_isTrackingServiceEnabled()) return;
  if (!props) return;
  mixpanel.people.set(props);
};

export const trackEvent = (eventName: string, props?: object) => {
  if (!_isTrackingServiceEnabled()) return;
  if (!mixpanel.track) return;
  mixpanel.track(eventName, props);
  trackLogRocketEvent(eventName, props as Parameters<typeof trackLogRocketEvent>[1]);
};

export const registerSuperProperties = (props: Record<string, unknown>) => {
  if (!_isTrackingServiceEnabled()) return;
  mixpanel.register(props);
};

export const setExperienceProperties = (experiences: ExperienceResult[]) => {
  if (!_isTrackingServiceEnabled()) return;
  if (!experiences?.length) return;

  const experienceProps = experiences.reduce(
    (acc, experience, index) => {
      const suffix = experiences.length > 1 ? `_${index}` : '';
      acc[`convert_experience_id${suffix}`] = experience.id;
      acc[`convert_variation_key${suffix}`] = experience.variationKey;
      return acc;
    },
    {} as Record<string, string>
  );

  mixpanel.people.set(experienceProps);
};
